webpackJsonp([49775852442029],{

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: grid;\n    grid-template-columns: repeat(4,1fr);\n    text-align: center;\n    background: teal;\n\n    @media only screen and (max-width: 568px) {\n        grid-template-columns: repeat(2,1fr);\n      }\n'], ['\n    display: grid;\n    grid-template-columns: repeat(4,1fr);\n    text-align: center;\n    background: teal;\n\n    @media only screen and (max-width: 568px) {\n        grid-template-columns: repeat(2,1fr);\n      }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: 10px;\n    color: #fff;\n    text-decoration: none;\n'], ['\n    padding: 10px;\n    color: #fff;\n    text-decoration: none;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Navigation = _styledComponents2.default.nav(_templateObject);
	
	var StyledLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject2);
	
	var Footer = function Footer() {
	    return _react2.default.createElement(
	        Navigation,
	        null,
	        _react2.default.createElement(
	            StyledLink,
	            { to: '/' },
	            'hq'
	        ),
	        _react2.default.createElement(
	            StyledLink,
	            { to: '/about', style: { background: '#18435A' } },
	            'a bit about me'
	        ),
	        _react2.default.createElement(
	            StyledLink,
	            { to: '/case-studies', style: { background: '#C1C1C1' } },
	            'some projects'
	        ),
	        _react2.default.createElement(
	            StyledLink,
	            { to: '/experience', style: { background: '#F18F01' } },
	            'my experience'
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-bottom: 100px;\n\n  & ul {\n    list-style-type: none;\n    margin-bottom: 50px;\n  }\n'], ['\n  margin-bottom: 100px;\n\n  & ul {\n    list-style-type: none;\n    margin-bottom: 50px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-height: 70px;\n'], ['\n  max-height: 70px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-top: 20px;\n  text-decoration: none;\n  color: #F18F01;\n  font-weight: 900;\n  transition: 0.5s;\n\n  &:hover {\n    color: teal;\n    transition: 0.5s;\n  }\n'], ['\n  margin-top: 20px;\n  text-decoration: none;\n  color: #F18F01;\n  font-weight: 900;\n  transition: 0.5s;\n\n  &:hover {\n    color: teal;\n    transition: 0.5s;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _header = __webpack_require__(51);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(25);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _contentWrapper = __webpack_require__(20);
	
	var _contentWrapper2 = _interopRequireDefault(_contentWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ItemWrapper = _styledComponents2.default.div(_templateObject);
	
	var Logo = _styledComponents2.default.img(_templateObject2);
	
	var StyledLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject3);
	
	var experiencePage = function experiencePage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_header2.default, { title: 'Where I\'ve Been', bgColor: '#F18F01', subTitle: 'companies I\'ve worked for' }),
	    _react2.default.createElement(
	      _contentWrapper2.default,
	      null,
	      _react2.default.createElement(
	        ItemWrapper,
	        null,
	        _react2.default.createElement(Logo, { src: '/imgs/yv-logo.png' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'YouView is a hybrid television platform for BT and TalkTalk. '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'My role at YouView covered many aspects of development such as testing, deployment and build processes.  As part of the Settings team I worked closely with product and UX teams to improve the user experience. I am now on the innovation team helping to develop new and exciting features.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Built out external Help application prototype using Typescript'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Implemented multiple setting options using Redux and RxJS'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Introduced CSS into the build process using Webpack, Stylelint and Sass'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Implemented HLS Video Trailers into UI as a solo project carrying out design, UX and development'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Built and deployed multiple API\u2019s connecting to AWS services such as Dynamodb and PostgreSQL'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Worked side by side with Android developers to port UI to Android TV devices'
	          )
	        ),
	        _react2.default.createElement(
	          StyledLink,
	          { to: '/case-studies' },
	          'Have a look at some projects I carried out at YouView'
	        )
	      ),
	      _react2.default.createElement(
	        ItemWrapper,
	        null,
	        _react2.default.createElement(Logo, { src: '/imgs/st-logo.png' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'SoleTrader.com are the largest DIFM website provider in the UK.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'During my time as tech lead as SoleTrader.com, I was in-charge of the design and development of all themes and build processes, When the need to develop our own internal application was prioritised, I stepped into a data architect role to help progress the task quickly.'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Bespoke WordPress Themes using HTML5, CSS, jQuery & PHP'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Building Internal systems using PHP, SQL and AngularJs'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Website development and maintenance including landing page conversions'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Agile project management'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '- Internal and external team management'
	          )
	        ),
	        _react2.default.createElement(
	          StyledLink,
	          { to: '/case-studies/my-soletrader' },
	          'Check out a major project I worked on while at SoleTrader.com'
	        )
	      )
	    ),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	exports.default = experiencePage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-experience-js-8dabb4437dc34b70e7db.js